import React from 'react';
import './offers.scss';

//import {Logout, statusOfferta,IsRole_Admin, IsRole_Manager, IsRole_Operator} from '../../globals';
import {Logout, IsRole_Admin, IsRole_Manager, IsRole_Operator, IsRole_Designer, IsRole_Technical,prioritaOptions, acquisizioneOptions,IsRole_SalesManager} from '../../globals';
import { useAuth } from  '../../contexts/auth'; 

import DataGrid, {
  Column,
 // Export,
  MasterDetail,
  Format,
  //Popup,
  Form,
  Button,
  Pager,
  Paging,
 // FilterRow,
  HeaderFilter,
  Lookup,
  Editing,
  Selection,
  Summary,
  Toolbar,
  //GroupItem,
  TotalItem,
  SearchPanel
} from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';

import SelectBox from 'devextreme-react/select-box';
import {Popup} from 'devextreme-react/popup';
import { createStore } from 'devextreme-aspnet-data';
import offerDetail from './offerDetail.js';

import  {Form as PopupForm, SimpleItem, EmptyItem, ButtonItem, GroupItem, Item,Label, TabbedItem, TabPanelOptions, Tab,RequiredRule } from 'devextreme-react/form';

import { useState, useEffect, useCallback,useRef } from "react";
import notify from 'devextreme/ui/notify';
//import Button from 'devextreme-react/button';
import {Button as ToolbarButton} from 'devextreme-react/button';
import { confirm } from 'devextreme/ui/dialog';
import { CheckBox } from 'devextreme-react/check-box';
//import { Toolbar } from 'devextreme-react';

import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';

//import FileUploader from 'devextreme-react/file-uploader';
//import {Popup as ExtPopup} from 'devextreme-react/popup';
//import { Button as PopupButton} from 'devextreme-react/button';

const serviceUrlX = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/ExcelService'
const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Offerta'
const serviceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OffertaRiepilogo'
const serviceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Offerte'
const serviceUrl4 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OffertaSoggetto'
const serviceUrl6 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa'
const serviceUrl7 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica'

const uploadActionUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/ExcelService/FileUpload';

const editorOptions = { readonly: true, format: '###,##0.00'};
const editorOptionsPerc = { readonly: true, format: "#0.00 '%'"};

const debug = process.env.ENTITY_DEBUG;


export default function Offers(props) {

  const projectId = props.projectId;
  var isInProject = false;
  if (props.isInProject)
    isInProject = props.isInProject;

  const initYear = isInProject? 0:new Date().getFullYear();
  const initIntermediario = isInProject? 0:210;
  
  //var offerDataGridRef = React.createRef();
  const offerDataGridRef = useRef(null);
  const fileInputRef = useRef(null);
  
  const [stati, setStati] = useState({});
  const [clienti, setClienti] = useState({});
  const [collaboratori, setCollaboratori] = useState({});
  const [concorrenti, setConcorrenti] = useState({});
  const [intermediari, setIntermediari] = useState({});
  const [fornitori, setFornitori] = useState({});
  const [tipiSoggetto, setTipiSoggetto] = useState({});
  const [tipiOfferta, setTipiOfferta] = useState({});
  const [categorieOfferta, setCategorieOfferta] = useState({});
  const [currentId, setCurrentId] = useState(0);
  const [currentRow, setCurrentRow] = useState(1);
  const [currentDocNo, setCurrentDocNo] = useState();
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [isGoToProject, setIsGoToProject] = useState(false);
  const [enableImport, setEnableImport] = useState(false);

  const [currentCopyRow, setCurrentCopyRow] = useState(0);
  const [currentDocCopyNo, setCurrentDocCopyNo] = useState();
  const [isRowCopySelected, setIsRowCopySelected] = useState(false);

  const [currentPrj, setCurrentPrj] = useState(0);
  const [currentPrjNo, setCurrentPrjNo] = useState();
  const [isPrjSelected, setIsPrjSelected] = useState(false);

  const [isStorico, setIsStorico] = useState(false);
  const [valute, setValute] = useState({});
  const [modalitaPagam, setModalitaPagam] = useState({});
  const [condizioniPagam, setCondizioniPagam] = useState({});
  //const [condizioniPagam2, setCondizioniPagam2] = useState({});
  const notesEditorOptions = { height: 38 };
  const notesEditorOptionsLarge = { height: 114, maxLength: 1000};
  const [isEditable, setIsEditable] = useState(true);
  const [anni, setAnni] = useState({});
  const [annoFilter, setAnnoFilter] = useState(initYear);
  const [intermediarioFilter, setIntermediarioFilter] = useState(initIntermediario);
  const [fornitoreFilter, setFornitoreFilter] = useState();
  const [statoFilter, setStatoFilter] = useState();
  const [descrizioneFilter, setDescrizioneFilter] = useState();
  const [rifOffertaFilter, setRifOffertaFilter] = useState();
  const [isPopupVisible, setPopupVisibility] = useState(false);
  const [statoCausali, setStatoCausali] = useState({});
  const [isOfferDeputy, setIsOfferDeputy] = useState(false);
  const [isOfferManager, setIsOfferManager] = useState(false);
  //const [currentDeputyUserId, setCurrentDeputyUserId] = useState();
  const [fornitoriArray, setFornitoriArray] = useState([]);
  const [currentIntermediarioDuplica, setCurrentIntermediarioDuplica] = useState();

  const togglePopup = () => {
    setPopupVisibility(!isPopupVisible);
  };

  const [isPopupVisible2, setPopupVisibility2] = useState(false);
  const togglePopup2 = () => {
    setPopupVisibility2(!isPopupVisible2);
  };

  const [isPopupVisible3, setPopupVisibility3] = useState(false);
  const togglePopup3 = () => {
    setPopupVisibility3(!isPopupVisible3);
  };

  const [isPopupVisible4, setPopupVisibility4] = useState(false);
  const togglePopup4 = () => {
    setPopupVisibility4(!isPopupVisible4);
  };

  const [isPopupVisible5, setPopupVisibility5] = useState(false);
  const togglePopup5 = () => {
    setPopupVisibility5(!isPopupVisible5);
  };

  //dialogo import modello offerta
  const [file, setFile] = useState(null); // Stato per il file selezionato
  const [message, setMessage] = useState(""); // Stato per il messaggio di conferma
  const [messageColor, setMessageColor] = useState("black"); // Colore del messaggio
  const [isChecked, setIsChecked] = useState(true);
  const [isChecked2, setIsChecked2] = useState(false);
  const [fileKey, setFileKey] = useState(Date.now()); // resetta l'input, ogni volta che fileKey cambia, React distrugge e ricrea l’input, svuotandolo


  const filterPayload = { 
    storico: isStorico,
    anno: annoFilter,
    intermediario: intermediarioFilter,
    stato: statoFilter,
    commessa: projectId,
    fornitore: fornitoreFilter,
    descrizione: descrizioneFilter,
    rifOfferta: rifOffertaFilter
  };

  const { user} = useAuth(); 

  if (!user) 
    Logout();
    //navigate("/login");
    //signOut;

  //console.log('Token:' + user.token);
  console.log('Username:' + user.username);
  console.log('User:' + user.name);
  console.log('UserId:' + user.userId);

  const userId = user.userId;
  const isManager =IsRole_Manager();
  if (debug === 1)
    console.log('IsManager: ' + isManager);

  const isOperator=IsRole_Operator();
  if (debug === 1)
    console.log('IsOperator: ' + isOperator);

  const isAdmin=IsRole_Admin();
  if (debug === 1)
    console.log('IsAdmin: ' + isAdmin);

  const isSalesManager=IsRole_SalesManager();
  if (debug === 1)
    console.log('IsSalesManager: ' + isSalesManager);
  
  const isDesigner =IsRole_Designer();
  if (debug === 1)
    console.log('IsDesigner: ' + isDesigner);

 const isTechnical =IsRole_Technical();
  if (debug === 1)
    console.log('IsTechnical: ' + isTechnical);

  const remoteDataSource = createStore({

    key: 'id',
    //loadUrl: serviceUrl3 + '/GetAction',
    loadUrl: serviceUrl3 + '/Find',
    
    onBeforeSend: (method, ajaxOptions) => {
      if (method === "load" ) {           
          var payload = ajaxOptions.data;
          payload.values = JSON.stringify(filterPayload);
          ajaxOptions.data = payload;          
      }  
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
     ;
    },
    insertUrl: serviceUrl + '/InsertAction',
    updateUrl:serviceUrl + '/UpdateAction',
    deleteUrl: serviceUrl + '/DeleteAction'
    
  });

  const remoteDataSource2 = createStore({

    key: 'id',
    loadUrl: serviceUrl2 + '/FindByOfferta/' + currentId,
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};   
    },  
    
  });

  const remoteDataSource4 = createStore({

    key: 'id',
    loadUrl: serviceUrl4 + '/FindByOfferta/' + currentId,
    updateUrl:serviceUrl4 + '/UpdateAction',
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};   
    },
    
  });

  const remoteDataSource5 = createStore({

    key: 'id',
    loadUrl: serviceUrl3 + '/GetAction',
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};   
    },
  });

  const remoteDataSource6 = createStore({

    key: 'id',
    loadUrl: serviceUrl6 + '/GetAction',
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};   
    },
  });

  useEffect(() => {

    const fetchData = async () => {

      const newServiceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OffertaStato';
      var newUrl =  newServiceUrl + "/GetAction";

      const newServiceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
      var newUrl2 =  newServiceUrl2 + "/GetClienti";

      const newServiceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Collaboratore';
      var newUrl3 =  newServiceUrl3 + "/GetCollaboratori";

      const newServiceUrl4 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Valuta';
      var newUrl4 =  newServiceUrl4 + "/GetAction";

      const newServiceUrl5 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/ModalitaPagamento';
      var newUrl5 =  newServiceUrl5 + "/GetAction";

      const newServiceUrl6 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/CondizioniPagamento';
      var newUrl6 =  newServiceUrl6 + "/GetAction";

      const newServiceUrl7 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
      var newUrl7 =  newServiceUrl7 + "/GetIntermediari";

      const newServiceUrl8 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/TipoSoggetto';
      var newUrl8 =  newServiceUrl8 + "/GetAction";

      const newServiceUrl9 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_AnniOfferte';
      var newUrl9 =  newServiceUrl9 + "/GetAction";

      const newServiceUrl10 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OffertaStatoCausale';
      var newUrl10 =  newServiceUrl10 + "/GetAction";

      const newServiceUrl11 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
      var newUrl11 =  newServiceUrl11 + "/GetConcorrenti";

      const newServiceUrl12 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OffertaTipo';
      var newUrl12 =  newServiceUrl12 + "/GetAction";

      const newServiceUrl13 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OffertaCategoria';
      var newUrl13 =  newServiceUrl13 + "/GetAction";

      const newServiceUrl14 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
      //var newUrl14 =  newServiceUrl14 + "/GetFornitoriAlias";
      var newUrl14 =  newServiceUrl14 + "/GetCostruttori";



      try {

        const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };
      
        const response = await fetch(newUrl);
        const json = await response.json();
        if (debug === 1)
          console.log(json);
        setStati(json);

        const response2 = await fetch(newUrl2,requestOptions);
        const json2 = await response2.json();
        if (debug === 1)
          console.log(json2);
        setClienti(json2);

        const response3 = await fetch(newUrl3,requestOptions);
        const json3 = await response3.json();
        if (debug === 1)
          console.log(json3);
        setCollaboratori(json3);

        const response4 = await fetch(newUrl4);
        const json4 = await response4.json();
        if (debug === 1)
          console.log(json4);
        setValute(json4);

        const response5 = await fetch(newUrl5);
        const json5 = await response5.json();
        if (debug === 1)
          console.log(json5);
        setModalitaPagam(json5);

        const response6 = await fetch(newUrl6);
        const json6 = await response6.json();
        if (debug === 1)
          console.log(json6);
        setCondizioniPagam(json6);

        const response7 = await fetch(newUrl7,requestOptions);
        const json7 = await response7.json();
        if (debug === 1)
          console.log(json7);
        setIntermediari(json7);

        const response8 = await fetch(newUrl8);
        const json8 = await response8.json();
        if (debug === 1)
          console.log(json8);
        setTipiSoggetto(json8);

        const response9 = await fetch(newUrl9);
        const json9 = await response9.json();
        if (debug === 1)
          console.log(json9);
        setAnni(json9);

        const response10 = await fetch(newUrl10);
        const json10 = await response10.json();
        if (debug === 1)
          console.log(json10);
        setStatoCausali(json10);

        const response11 = await fetch(newUrl11,requestOptions);
        const json11 = await response11.json();
        if (debug === 1)
          console.log(json11);
        setConcorrenti(json11);

        const response12 = await fetch(newUrl12);
        const json12 = await response12.json();
        if (debug === 1)
          console.log(json12);
        setTipiOfferta(json12);

        const response13 = await fetch(newUrl13);
        const json13 = await response13.json();
        if (debug === 1)
          console.log(json13);
        setCategorieOfferta(json13);

        const response14 = await fetch(newUrl14,requestOptions);
        const json14 = await response14.json();
        if (debug === 1)
          console.log(json14);
        setFornitori(json14);

        const arr1 = Array.isArray(json14) ? json14 : (Array.isArray(json14.data) ? json14.data : []);
        //console.log("DEBUG: parsed fornitori array (length):", arr1.length);
        setFornitoriArray(arr1);

      } catch (error) {
        console.log("error", error);
      }
    };

    fetchData();
  }, []);

  const hideEditButton = useCallback((e) => {
    return e.row.data.statoId === 1 || e.row.data.statoId === 10;
  }, []);

  const duplica= (idOfferta) => {
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Offerta/Duplicate/' + idOfferta + '/' + currentIntermediarioDuplica;
  
    const requestOptions = {
      method: 'PUT',
      //body: JSON.stringify(detailAllievo),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 1000);
        //offerDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }

  const copia= (idOfferta) => {
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Offerta/NewVersion/' + idOfferta;
  
    const requestOptions = {
      method: 'PUT',
      //body: JSON.stringify(detailAllievo),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
        offerDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }

  // const creaCommessa= (idOfferta) => {
  //   const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa/CreateFullProject/' + idOfferta;
  
  //   const requestOptions = {
  //     method: 'PUT',
  //     //body: JSON.stringify(detailAllievo),
  //     headers: {
  //       'Content-Type': 'application/json',
  //       Authorization: `Bearer ${user.token}`
  //     }
  //   };
  
  //   return fetch(url, requestOptions)
  //     .then(response => {
  //       if(response.ok) return response.json();
  //       //Global.CheckResponseAuth(response);
  //       return null;
  //     })
  //     .then(data => { 
  //       ;
  //       setTimeout(() => { 
  //         notify(data.message, data.success ? 'success' : 'error', 2000);         
  //       }, 100);
  //       offerDataGridRef.instance().refresh();
  //     })
  //     .catch(error => { notify(error, 'error', 5000); }); 
  // }

//   const creaCommessa= (project) => {
//     const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa/CreateFullProjectByOfferta';
  
//     const requestOptions = {
//       method: 'POST',
//       body: JSON.stringify(project),
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: `Bearer ${user.token}`
//       }
//     };
  
// return fetch(url, requestOptions)
//   .then(async response => {

//     const text = await response.text();

//     if(!response.ok){
//       console.error(text);
//       throw new Error(text);
//     }

//     return JSON.parse(text);
//   })
//       .then(data => { 
//         ;
//         setTimeout(() => { 
//           notify(data.message, data.success ? 'success' : 'error', 2000);         
//         }, 100);
//         offerDataGridRef.instance().refresh();
//       })
//       .catch(error => { notify(error, 'error', 5000); }); 
//   }

const creaCommessa = async (project) => {

  const url = `${process.env.REACT_APP_WEBAPP_DOMAIN}/api/Commessa/CreateFullProjectByOfferta`;

  try {

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      },
      body: JSON.stringify(project)
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.message || "Errore nella creazione della commessa");
    }

    notify(data.message, data.success ? 'success' : 'error', 2000);

    //offerDataGridRef.instance().refresh();
    offerDataGridRef.current?.instance()?.getDataSource()?.reload();

    return data;

  } catch (error) {

    console.error(error);

    notify(error.message || "Errore di comunicazione con il server", 'error', 5000);
  }
};

  const aggiungiACommessa= () => {

    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa/AddToProject/' + currentPrj + '/' +currentRow;
  
    const requestOptions = {
      method: 'PUT',
      //body: JSON.stringify(params),
      headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
        offerDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }


  function importa() {
    let result = confirm("<i>Procedere con l'importazione?</i>", "Importa righe offerta da modello");
        result.then((dialogResult) => {
          if  (dialogResult) {
            importFile();
          }  
        });
  }

  function importFile(t) {
  
    const url =  serviceUrlX + "/ImportFromOfferTemplate/"+currentRow;

    const requestOptions = {
      method: 'POST',
      //method: 'PUT',
      //body: JSON.stringify(t),
      headers: {
        'Content-Type': 'application/json',
        //Authorization: `Bearer ${user.token}`
      }
    };

    fetch(url, requestOptions)
      .then(response => { 
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;             
      })
      .then(data => {
        //notify(data.message, data.success ? 'success' : 'error', 5000);
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 5000);         
        }, 100);
        offerDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 5000); });

  };  

  function customizeText(data) {
    return `Offerte: ${data.value}`;
  }

  // function onRowSelectionChanged(e) {
  //   console.log("SELECTED: " + e.currentSelectedRowKeys);
  //   setCurrentId(e.currentSelectedRowKeys);
  // }

  // function onRowExpanded(e) {
  //   console.log("EXPANDED: " + e.key);
  //   setCurrentId(e.key);
  // }

  // function isRiepilogoGroup(item) {
  //   return item && item.itemType === 'group' && item.caption === 'Riepilogo';
  // }

  function notToDelete(status) {
    console.log("STATUS: " + status);
    //if(status === 1 || status === 4 || status === 5 || status === 7) 
    if(status !== 1 && status !== 10)
      return true
    else
      return false     
  };

  function onRowRemoving(e) {
    const isCanceled =  notToDelete(e.data.statoId);
    console.log("ISCANCELED: " + isCanceled);
    if(isCanceled === true)
      notify("Non è possibile eliminare l'Offerta", 'error', 2000);  

    e.cancel = isCanceled;  
  };

  function onEditingStart(e) {
    //console.log("EDITING: " + e.key);
    //QUESTO PROVOCA IL DOPPIO REFRESH DEL POPUP DELLA TESTATA
    setCurrentId(e.key);
  }

  function onInitNewRow(e) {
    e.data.fornitoriIds = "";
  };

  function onRowInserting(e) {
    e.data.createBy = user.name;
    //se il nuovo stato a cui passare è "Approvata" e l'utente non è admin blocca il salvataggio
    // if (e.data !== undefined && e.data.statoId === 6 && !isAdmin)
    // {
    //   e.cancel = true;
    //   notify("L'utente non ha i permessi per approvare l'offerta", 'error', 5000);
    // }
    // else
    //   e.cancel = false;
  };

  function onRowUpdating(e) {
    e.newData.updateBy = user.name;
    //se il nuovo stato a cui passare è "Approvata" e l'utente non è admin blocca il salvataggio
    if (e.newData.statoId !== undefined && e.newData.statoId === 6 && !isAdmin)
    {
      e.cancel = true;
      notify("L'utente non ha i permessi per approvare l'offerta", 'error', 5000);
    //se il nuovo stato a cui passare è "Da Approvare" e il flag ApprovazioneTecnica non è checked blocca il salvataggio
    } else if (e.newData.statoId !== undefined && e.newData.statoId === 7 && e.oldData.approvazioneTecnica !== true)
    {
      e.cancel = true;
      notify("E'possibile far passare l'Offerta nello stato Da Approvare solo se è presente l'Approvazione Tecnica: " + e.oldData.approvazioneTecnica, 'error', 5000);
    }
    else
      e.cancel = false;
  };

  const onEditorPreparing = (e) => {

    // if(e.dataField === "deputyUserId" && e.parentType ==="dataRow"){
    //   IsOffer_Deputy(e.row.data.deputyUserId);
    // }

    if(e.dataField === "clienteId" && e.parentType ==="dataRow"){
      e.editorOptions.disabled = e.row.data && !(e.row.data.statoId === 1 || e.row.data.statoId === 10) && e.row.data.statoId != null;
    }
    if(e.dataField === "destinazioneId" && e.parentType ==="dataRow"){
      e.editorOptions.disabled = e.row.data && !(e.row.data.statoId === 1 || e.row.data.statoId === 10) && e.row.data.statoId != null;
    }
    if(e.dataField === "intermediarioId" && e.parentType ==="dataRow"){
      e.editorOptions.disabled = e.row.data && !(e.row.data.statoId === 1 || e.row.data.statoId === 10) && e.row.data.statoId != null;
    }
    if(e.dataField === "destinazione" && e.parentType ==="dataRow"){
      e.editorOptions.disabled = e.row.data && !(e.row.data.statoId === 1 || e.row.data.statoId === 10) && e.row.data.statoId != null;
    }
    if(e.dataField === "localita" && e.parentType ==="dataRow"){
      e.editorOptions.disabled = e.row.data && !(e.row.data.statoId === 1 || e.row.data.statoId === 10) && e.row.data.statoId != null;
    }

    //se  Completata (11) Da Approvare (7) o Approvata (6) o Consegnata (2) può modificare lo stato admin o salesmanager
    if(e.dataField === "statoId" && e.parentType ==="dataRow"){
    //   if (!isAdmin && !isSalesManager && (e.row.data.statoId === 11 || e.row.data.statoId === 7 || e.row.data.statoId === 6 || e.row.data.statoId === 2) )
    //     e.editorOptions.disabled = true;

      if (isAdmin || isSalesManager)
        e.editorOptions.disabled = false;
      else if ((isOfferDeputy || isOfferManager) && e.row.data.statoId === 2)
        e.editorOptions.disabled = false;
      else if (e.row.data.statoId !== 11 && e.row.data.statoId !== 7 && e.row.data.statoId !== 6 && e.row.data.statoId !== 2)
        e.editorOptions.disabled = false;
      else
        e.editorOptions.disabled = true;
    }

    if(e.dataField === "clienteId" && e.parentType ==="dataRow"){
      if (!(e.row.data.statoId === 1 || e.row.data.statoId === 10) || e.row.data.statoId === null)
        setIsEditable(false)
      else
        setIsEditable(true)
    }

    if((e.dataField === "concorrenteId" || e.dataField === "statoCausaleId") && e.parentType ==="dataRow"){
      e.editorOptions.showClearButton = true;
    }
    // if (e.parentType === "dataRow" && e.dataField === "updateBy") {
    //   console.log("USERNAME " + user.name);
    //   e.setValue(user.name);
    // }

    //il flag approvazione tecnica lo possono modificare solo i ruoli TECHNICAL e ADMIN
    if(e.dataField === "approvazioneTecnica" && e.parentType ==="dataRow"){
      e.editorOptions.disabled = e.row.data && !isAdmin && !isTechnical;
    }

    if (e.parentType === "form" && e.dataField === "fornitoriIds") {
      
      // --- Gestione del cambiamento (Array di numeri -> CSV) ---
      // QUESTA PARTE DEVE RIMANERE per il salvataggio
      e.editorOptions.onValueChanged = (ev) => {
        const arr = Array.isArray(ev.value) ? ev.value : [];
        const csv = arr.length ? arr.join(",") : "";
        
        // Usa e.setValue per aggiornare il form data con la STRINGA CSV
        e.setValue(csv); 
      };
    }

  }      
  
  function onSaving(e) {
    // e.changes contiene tutti gli aggiornamenti/inserimenti/cancellazioni
    e.changes.forEach(change => {
      // Intercetta solo i dati che saranno inviati (insert o update)
      if (change.type === 'update' || change.type === 'insert') {
        const dataToSave = change.data;
        
        // Controlla se 'fornitoriIds' è presente e se è un array
        if (dataToSave.hasOwnProperty('fornitoriIds') && Array.isArray(dataToSave.fornitoriIds)) {
          
          // Il valore è arrivato qui come Array [200, 201]. Dobbiamo convertirlo in CSV "200,201".
          const arr = dataToSave.fornitoriIds;
          const csv = arr.join(",");
          
          // Sovrascrivi il campo 'fornitoriIds' con la stringa CSV
          dataToSave.fornitoriIds = csv;
          
          // DEBUG: verifica cosa viene inviato (opzionale)
          //console.log("DEBUG: fornitoriIds convertito in CSV:", dataToSave.fornitoriIds);
        }
      }
    });
  }

  function refreshDataGrid() {
    offerDataGridRef.instance().refresh();
  }

  function newVersion(e) {
    let result = confirm("<i>Procedere con la creazione di una nuova revisione?</i>", "Nuova revisione");
    result.then((dialogResult) => {
      if  (dialogResult) {
        copia(currentRow);
      }  
    });
  }

  function duplicate(e) {
    let result = confirm("<i>Procedere con la duplicazione dell'offerta?</i>", "Duplicazione Offerta");
    result.then((dialogResult) => {
      if  (dialogResult) {
        //duplica(currentRow);
        //togglePopup4
        setPopupVisibility4(true);
      }  
    });
  }



  function printOffer(id) {

    const url =  serviceUrl3 + "/CreateOffertaPDF/" + id;

    const requestOptions = {
      method: 'POST',
      //body: JSON.stringify(t),
      headers: {
        'Content-Type': 'application/json',
         Authorization: `Bearer ${user.token}`
      }
    };

    fetch(url, requestOptions)
      .then(response => { 
        if(response.ok) return response.blob();        
        //Global.CheckResponseAuth(response);
      })
      .then(blob => {

        setTimeout(() => {          
        }, 1500);

        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        var slug = "Offerta";

        a.download = slug + ".pdf";
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();    
        a.remove();  //afterwards we remove the element again 
        
      })

      .catch(error => { notify(error, 'error', 5000); });

  };  


  function print(e) {
    printOffer(currentRow);
    notify("Stampa offerta: " + currentDocNo);
  }

  function createProject(e) {
    let result = confirm("<i>Procedere con la creazione di una commessa a partire dall'offerta selezionata?</i>", "Nuova Commessa");
    result.then((dialogResult) => {
      if  (dialogResult) {
        //creaCommessa(currentRow);
        setPopupVisibility5(true);
      }  
    });
  }

  function addToProject(e) {
    let result = confirm("<i>Aggiungere l'offerta selezionata alla Commessa in corso?</i>", "Aggiungi a Commessa");
    result.then((dialogResult) => {
      if  (dialogResult) {
        aggiungiACommessa();
        setPopupVisibility2(false);
      }  
    });
  }

  function onRowSelectionChanged({ selectedRowsData }) {
    const data = selectedRowsData[0];
    if (data !== null && data !== undefined) {
      setCurrentRow(data.id);
      setCurrentDocNo(data.numero);
      setIsRowSelected(true);
     

      const isD = (data.deputyUserId !== undefined && data.deputyUserId !== null && data.deputyUserId === userId) ? true : false;
      const isM = (data.managerUserId !== undefined && data.managerUserId !== null && data.managerUserId === userId) ? true : false;
      //if(isD)
        setIsOfferDeputy(isD);
      //else
      //  setIsOfferDeputy(false);
   
      setIsOfferManager(isM);


    } else{
      setIsRowSelected(false);
    }
    if (data != null && data.statoId === 3)
      setIsGoToProject(true);
    else
      setIsGoToProject(false);

    //controllo import da modello
    if (data != null && (data.statoId === 1 || data.statoId === 10 ))
      setEnableImport(true);
    else
      setEnableImport(false);  
  }

  function onCheckValueChanged(e)  {
    setIsStorico(e.value);
    setFornitoreFilter(null);
    setDescrizioneFilter("");
    setRifOffertaFilter("");
  };

function onToolbarPreparing(e) {
  if(!isInProject)
  {
    e.toolbarOptions.items.push({
        widget: 'dxButton',
        name: "myexport",
        location: "before",
        options: {
            icon: "exportxlsx",
            hint: "Esporta in Excel",
            onClick: function() {
              onExporting(e);
            }
        }
    });
  }
}

function onExporting(e) {
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet('Offerte');

  exportDataGrid({
    component: e.component,
    worksheet,
    autoFilterEnabled: true,
  }).then(() => {
    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Offerte.xlsx');
    });
  });
  e.cancel = true;
}


// function onExporting(e) {
//    const workbook = new Workbook();
//    const worksheet = workbook.addWorksheet('Offerte');

//   exportDataGrid({
//     component: e.component,
//     worksheet,
//     autoFilterEnabled: true,
//   }).then(() => {
//     const rowCount = e.component.getVisibleRows().length;
//     const newColIndex = worksheet.lastColumn.number + 1;

//     // Intestazione extra con stile
//     const headerCell = worksheet.getRow(1).getCell(newColIndex);
//     headerCell.value = "Rif. Offerta Forn.";
//     headerCell.font = { bold: true };
//     headerCell.alignment = { horizontal: "center" };

//     // Popolamento righe
//     for (let i = 0; i < rowCount; i++) {
//       worksheet.getRow(i + 2).getCell(newColIndex).value = rifOffertaFilter;
//     }

//     // Aggiornare il filtro per includere anche la colonna extra
//     worksheet.autoFilter = {
//       from: { row: 1, column: 1 },
//       to: { row: 1, column: newColIndex }, // esteso fino alla nuova colonna
//     };

//     return workbook.xlsx.writeBuffer();
//   }).then((buffer) => {
//     saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Offerte.xlsx');
//   });

//   e.cancel = true;
// }

  const statusOfferta = (e) => {
    if (e.rowType === "data") {
        if (e.column.dataField === "statoId") 
        {  if (e.data.statoId === 1)
            e.cellElement.style.cssText = "color: white; background-color: #558ea7";
           else if  
           (e.data.statoId === 2)
            e.cellElement.style.cssText = "color: white; background-color: orange";
            else if  
           (e.data.statoId === 3)
            e.cellElement.style.cssText = "color: white; background-color: green";
            else if  
            (e.data.statoId === 4)
             e.cellElement.style.cssText = "color: white; background-color: red";
             else if 
             (e.data.statoId === 5)
             e.cellElement.style.cssText = "color: white; background-color: grey";
             else if 
             (e.data.statoId === 6)
             e.cellElement.style.cssText = "color: white; background-color: blue";
             else if 
             (e.data.statoId === 7)
             e.cellElement.style.cssText = "color: white; background-color: #30B7E0";
             else if 
             (e.data.statoId === 8)
             e.cellElement.style.cssText = "color: white; background-color: #E0CF1C";
             else if 
             (e.data.statoId === 9)
             e.cellElement.style.cssText = "color: white; background-color: #1BE02B";
             else if 
             (e.data.statoId === 10)
             e.cellElement.style.cssText = "color: white; background-color: #DDBBFF";
             else if 
             (e.data.statoId === 11)
             e.cellElement.style.cssText = "color: white; background-color:rgb(128, 86, 226)";
             
            // or
            //e.cellElement.classList.add("my-class");
        }
    }
  }

const selectBoxOptions = {
  width: 150,
  items: anni,
  valueExpr: 'id',
  displayExpr: 'annoDoc',
  onValueChanged: (args) => {
    setAnnoFilter(args.value);
  },
  value: annoFilter
};

const selectBoxOptions2 = {
  width: 210,
  items: intermediari,
  valueExpr: 'id',
  displayExpr: 'ragioneSociale',
  placeholder:"<Azienda>",
  showClearButton:true,
  onValueChanged: (args) => {
    setIntermediarioFilter(args.value);
  },
  value: intermediarioFilter,
};

const selectBoxOptions3 = {
  width: 180,
  items: stati,
  valueExpr: 'id',
  displayExpr: 'nome',
  placeholder:"<Stato>",
  showClearButton:true,
  onValueChanged: (args) => {
    setStatoFilter(args.value);
  },
  value: statoFilter
};

const selectBoxOptions4 = {
  width: 210,
  items: fornitori,
  valueExpr: 'id',
  displayExpr: 'alias',
  placeholder:"<Fornitore>",
  showClearButton:true,
  searchEnabled: true,
  onValueChanged: (args) => {
    setFornitoreFilter(args.value);
  },
  value: fornitoreFilter,
};

const textBoxOptions = {
  width: 200,
  placeholder:"<Descriz. Articolo>",
  onValueChanged: (args) => {
    setDescrizioneFilter(args.value);
  },
  value: descrizioneFilter
};

const textBoxOptions2 = {
  width: 200,
  placeholder:"<Rif. Offerta Fornitore>",
  onValueChanged: (args) => {
    setRifOffertaFilter(args.value);
  },
  value: rifOffertaFilter
};

const addButtonOptions = {
  icon: 'plus',
  hint: 'Nuova Offerta'
  // onClick: () => {
  //   notify('Add button has been clicked!');
  // },
};

  const copiaRighe= () => {

    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Offerta/CopiaRighe/' + currentCopyRow + '/' +currentRow;
  
    const requestOptions = {
      method: 'PUT',
      //body: JSON.stringify(params),
      headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }

    function copyRows() {
      let result = confirm("<i>Procedere con la copia delle righe?</i>", "Copia Righe Offerta");
      result.then((dialogResult) => {
        if  (dialogResult) {
          setPopupVisibility(false);
          copiaRighe();
        }  
      });
    }

    function cancelCopyRows()  {
      setPopupVisibility(false);
      setCurrentCopyRow(0);
      setCurrentDocCopyNo(0);
      setIsRowCopySelected(false);
    };

    function onRowSelectionChangedCopy({ selectedRowsData }) {
      const data = selectedRowsData[0];
      if (data != null) {
        setCurrentCopyRow(data.id);
        setCurrentDocCopyNo(data.numero);
        setIsRowCopySelected(true);
      } else{
        setCurrentCopyRow(0);
        setIsRowCopySelected(false);
      }
    }
    const allowedPageSizes = [5, 10, 20];
    const renderContent = () =>  {
      return (
        <div>

    { isRowCopySelected &&
      <p>Copia le righe dall'Offerta <b>{currentDocCopyNo}</b></p>
    }
       
        <DataGrid id="grid-popup"
          //ref={ref => offerDataGridRef = ref}
          className={'dx-card wide-card'}
          dataSource={remoteDataSource5}
          showBorders={true}

          focusedRowEnabled={true}
          defaultFocusedRowIndex={0}
          onSelectionChanged={onRowSelectionChangedCopy}
          //onRowExpanded={onRowExpanded}
          //onEditingStart={onEditingStart}
        
        >
          <Pager
              showPageSizeSelector={false}
              allowedPageSizes={allowedPageSizes}
              showNavigationButtons={true}
              showInfo={true}
          />
          <Selection mode="single" />
          <Paging defaultPageSize={10} />
          <SearchPanel visible={true}
            width={240}
            placeholder="Cerca..."
          />
          <Toolbar>
            <Item location="after">
              <ToolbarButton className="offer-toolbar"
                icon='todo'
                hint='Conferma'
                disabled={!isRowCopySelected}
                onClick={copyRows} 
              />
            </Item>
            <Item location="after">
              <ToolbarButton className="offer-toolbar"
                icon='revert'
                hint='Annulla'
                onClick={cancelCopyRows} 
              />
            </Item>    
            <Item name="searchPanel" className="offer-toolbar"/>
          </Toolbar>
          <Column dataField="id" visible={false}/>
          <Column dataField="numero" caption="Num." width={110}/>
          <Column dataField="dataDoc" dataType="date" caption="Data doc." width={130}/>
          <Column dataField="clienteId" caption="Cliente" width={280}>
            <Lookup dataSource={clienti} valueExpr="id" displayExpr="ragioneSociale" />
          </Column>
          <Column dataField="oggetto" caption="Oggetto" />
          <Column dataField="importoTotale"  width={100} caption="Importo">
            <Format type="fixedPoint" precision={2} />
          </Column>
        </DataGrid>
        </div>            
      )
    }

    function cancelAddToProject()  {
      setPopupVisibility2(false);
      setCurrentPrj(0);
      setCurrentPrjNo(0);
      setIsPrjSelected(false);
    };

    function onRowSelectionChangedPrj({ selectedRowsData }) {
      const data = selectedRowsData[0];
      if (data != null) {
        setCurrentPrj(data.id);
        setCurrentPrjNo(data.codice);
        setIsPrjSelected(true);
      } else{
        setCurrentPrj(0);
        setIsPrjSelected(false);
      }
    }

    const renderContent2 = () =>  {
      return (
        <div>

    { isPrjSelected &&
      <p>Aggiungi l'Offerta alla Commessa <b>{currentPrjNo}</b></p>
    }
       
        <DataGrid id="grid-popup2"
          className={'dx-card wide-card'}
          dataSource={remoteDataSource6}
          showBorders={true}

          focusedRowEnabled={true}
          defaultFocusedRowIndex={0}
          onSelectionChanged={onRowSelectionChangedPrj}
        >
          <Pager
              showPageSizeSelector={false}
              allowedPageSizes={allowedPageSizes}
              showNavigationButtons={true}
              showInfo={true}
          />
          <Selection mode="single" />
          <Paging defaultPageSize={10} />
         
          <Toolbar>
            <Item location="after">
              <ToolbarButton className="offer-toolbar"
                icon='todo'
                hint='Conferma'
                disabled={!isPrjSelected}
                onClick={addToProject} 
              />
            </Item>
            <Item location="after">
              <ToolbarButton className="offer-toolbar"
                icon='revert'
                hint='Annulla'
                onClick={cancelAddToProject} 
              />
            </Item>    
        
          </Toolbar>
          <Column dataField="id" visible={false}/>
          <Column dataField="codice" caption="Codice" width={110}/>
          <Column dataField="nome" dataType="date" caption="Nome" />
          <Column dataField="clienteId" caption="Cliente" >
            <Lookup dataSource={clienti} valueExpr="id" displayExpr="ragioneSociale" />
          </Column>
        </DataGrid>
        </div>            
      )
    }
   
const onValueChangedDuplica = useCallback((e) => {
  //console.log(e.previousValue);
  //console.log(e.value);
  setCurrentIntermediarioDuplica(e.value)
}, []);

const renderContent4 = () => {
  return (
    <div>
      <p>Selezionare l'Azienda di destinazione per l'Offerta duplicata</p>
      <div className="dx-fieldset">        
        <div className="dx-field">  
          <div className="dx-field-label">Azienda</div>
          <div className="dx-field-value">
            <SelectBox
              items={intermediari}
              valueExpr="id"
              displayExpr="ragioneSociale"
              showClearButton={true}
              onValueChanged={onValueChangedDuplica}
            />
          </div>
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
        <div style={{ marginRight: 12 }}>
          <ToolbarButton 
            text="Annulla"
            type="normal"
            onClick={onCloseDuplica}
          />
        </div>
        <div style={{ marginRight: 12 }}>
          <ToolbarButton
            text="Conferma"
            type="success"
            onClick={onConfirmDuplica}
            disabled={!currentIntermediarioDuplica}
          />
        </div>
      </div>
    </div>
  );
};

const newProjectBean = {
  id: 0,
  offertaId: null,
  nome: null,
  dataInizio: new Date(),
  descrizione: '',
  projectManagerId: null,
  assistantPMId: null,
  referenteTecnicoId: null,
  createBy: user.name
};


const submitButtonOptions = {
    text: "Crea Commessa",
    type:"success",
    useSubmitBehavior: true
  };

const closeButtonOptions = {
  text: 'Annulla',
  onClick: function () {
    setPopupVisibility5(!isPopupVisible5);
  }
};


const handleSubmit5 = (e) => {
  //newProjectBean.offertaId = currentId;
  const project = {
    ...newProjectBean,
    offertaId: currentRow
  };
  setPopupVisibility5(!isPopupVisible5);
  e.preventDefault();
  creaCommessa(project);
 
  // invio dati
  console.log(project);
}; 

const collaboratoriOptions={ items: collaboratori, displayExpr: 'cognome', valueExpr: 'id' }
 
const renderContent5 = () => {
    return (
  <>
    <form  onSubmit={handleSubmit5} action="#">
      <PopupForm
        id="form5"
        colCount={2}
        formData={newProjectBean}
      >
       <SimpleItem
          dataField="offertaId"  
          visible={false}
       >
      </SimpleItem>
        
        <SimpleItem
          dataField="nome"  
        >
           <RequiredRule message="Il nome è obbligatorio" />
        </SimpleItem> 
        <SimpleItem
          dataField="dataInizio"
          editorType="dxDateBox"
        >
          <RequiredRule message="La data di inizio è obbligatoria" />
        </SimpleItem>        

        <SimpleItem
          colSpan={2}
          dataField="descrizione"
        > 
        </SimpleItem>
        
        <SimpleItem dataField="projectManagerId" 
          editorType="dxSelectBox"
          editorOptions={collaboratoriOptions} >
            <Label text={`Project Manager`} />
            <RequiredRule message="Selezionare il Project Manager" />
        </SimpleItem>

        <SimpleItem dataField="assistantPMId" 
          editorType="dxSelectBox"
          editorOptions={collaboratoriOptions}>
            <Label text={`Assistente`} />
            <RequiredRule message="Selezionare l'Assistente" />
        </SimpleItem>

        <SimpleItem dataField="referenteTecnicoId" 
          editorType="dxSelectBox"
          editorOptions={collaboratoriOptions}>
            <Label text={`Referente Tecnico`} />
            <RequiredRule message="Selezionare il Referente Tecnico" />
        </SimpleItem>

        <SimpleItem></SimpleItem>
        <EmptyItem colSpan={2} />

   <GroupItem colSpan={2} colCount={2}>
  <ButtonItem
    horizontalAlignment="right"
    buttonOptions={submitButtonOptions}
  />
  <ButtonItem
    horizontalAlignment="left"
    buttonOptions={closeButtonOptions}
  />
</GroupItem>
                  
      </PopupForm>
    </form>
  
  </>
    );
};

function onCloseDuplica(){
  setPopupVisibility4(false);
  setCurrentIntermediarioDuplica(null);
};

function onConfirmDuplica(){
  setPopupVisibility4(false);
  duplica(currentRow);
  //setCurrentIntermediarioDuplica(null);
};

const handleOnChange = () => {
  setIsChecked(!isChecked);
};

const handleOnChange2 = () => {
  setIsChecked2(!isChecked2);
};

function closePopup(){
  setPopupVisibility3(false);
};



const renderContent3 = () =>  {
        
  //Funzione per gestire il cambio del file
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setMessage("");
  };

  // Funzione "annulla"
  const handleCancel = () => {
    setFile(null);
    setMessage("Selezione annullata");
    setMessageColor("orange");
    setFileKey(Date.now()); // forza il reset dell’input file
  };

  // Funzione per gestire l'invio del modulo
  const handleSubmit = async (e) => {
    e.preventDefault(); // Previene il comportamento predefinito del form

    if (!file) {
      setMessage("Nessun file selezionato!");
      setMessageColor("red");
      return;
    }

    // Controlla l'estensione del file
    const allowedExtensions = /\.xlsx$/i;
    if (!allowedExtensions.test(file.name)) {
      setMessage("E' possibile caricare solo file con estensione .xlsx.");
      setMessageColor("red");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("offerId", currentRow);
    formData.append("addInfo", isChecked);
    formData.append("addComment", isChecked2);

    try {
      const response = await fetch(uploadActionUrl, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Errore durante il caricamento del file.");
      }

      const result = await response.json();
      //setMessage(result.Message); 
      //setMessageColor("green");
      //Imposta il messaggio di successo
      notify(result.message, result.success ? 'success' : 'error',3000);
      setTimeout(() => { 
        if(result.success)
          closePopup();
        else
          //setFile(null);    
        ;     
      }, 3000);
    } catch (error) {
      //setMessage(error.message); 
      //setMessageColor("red");
      //Imposta il messaggio di errore
      notify(error.message, 'Errore', 3000);
    }
  };

  return (
    <div>
      <h4>Verranno importate le righe del modello offerta selezionato</h4>
      <p>Eventuali righe presenti saranno sovrascritte</p>
      <br></br>
      <form onSubmit={handleSubmit}>
        <div>
          <input type="checkbox" id="addInfo" name="addInfo" checked={isChecked} onChange={handleOnChange}/>Aggiungi Suddivisione Importi e Pagamenti
        </div>
        <br></br>
        <div>
          <input type="checkbox" id="addComment" name="addComment" checked={isChecked2} onChange={handleOnChange2}/>Aggiungi Commenti/Deviazioni
        </div>
        <br></br>
        <input key={fileKey} type="file" onChange={handleFileChange} accept=".xlsx"/>
        <input type="hidden" value={currentRow} />
        <div style={{ marginTop: "20px" }}>
          <button className="mysubmit" type="submit">Carica</button>
          <button type="button" className="mysubmit" style={{ marginLeft: "10px", backgroundColor: "lightcoral" }} onClick={handleCancel}
          >
          Annulla
          </button>
        </div>
      </form>
      {message && (
        <div
          style={{
            marginTop: "20px",
            padding: "10px",
            border: "1px solid #ccc",
            backgroundColor: "#f9f9f9",
            color: messageColor,
          }}
        >
          {message}
        </div>
      )}
    </div>
  );
}

  return (
  <React.Fragment>
    { !isInProject &&  <h2 className={'content-block'}>Elenco Offerte</h2> }
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
 
      
      
      <DataGrid id="grid-container"
        //ref={ref => offerDataGridRef = ref}
        ref={offerDataGridRef}
        className={'dx-card wide-card'}
        dataSource={remoteDataSource}
        showBorders={true}
    
        onSelectionChanged={onRowSelectionChanged}
        //onRowExpanded={onRowExpanded}
        onEditingStart={onEditingStart}
        onRowRemoving={onRowRemoving}
        onEditorPreparing={onEditorPreparing}
        onExporting={onExporting}
        //onOptionChanged={onOptionChanged}
        onCellPrepared={statusOfferta}
        onRowUpdating={onRowUpdating}
        onRowInserting={onRowInserting}
        onToolbarPreparing = {onToolbarPreparing}
        dateSerializationFormat= {'yyyy-MM-dd'}

        //aggiunte per gestione campo multivalue fornitori
        onInitNewRow={onInitNewRow}
        // converte l'array in csv
        onSaving={onSaving}
        //converte il csv in array
        //customizeColumns={customizeColumns}
      >
        <SearchPanel visible={!isInProject}
          width={240}
          placeholder="Cerca..."
          //text={searchPanelValue} 
        />
        
      { !isInProject
    &&   
        <Toolbar>
        
          <Item name="addRowButton"  options={addButtonOptions} location="before"/>
          <Item location="before">
            <ToolbarButton className="offer-toolbar"
              icon='hidepanel'
              hint='Importa massivo'
              onClick={importa} 
              visible={isDesigner}
            />
          </Item>
          <Item location="before">
            <ToolbarButton className="offer-toolbar"
            icon='import'
            hint='Importa modello'
            onClick={togglePopup3} 
            disabled={!enableImport} 
            />
          </Item>
          
          <Item location="before">
            <ToolbarButton className="offer-toolbar"
              icon='refresh'
              hint='Aggiorna'
              onClick={refreshDataGrid} 
              />
          </Item>
          <Item location="before">
            <ToolbarButton className="offer-toolbar"
              icon='copy'
              hint='Duplica'
              onClick={duplicate}
              disabled={!isRowSelected} />
          </Item>
          <Item location="before">
            <ToolbarButton className="offer-toolbar"
              icon='inserttable'
              hint='Nuova revisione'
              onClick={newVersion}
              disabled={!isRowSelected} />
          </Item>
          <Item location="before">
            <ToolbarButton className="offer-toolbar"
              icon='increaseindent'
              hint='Copia Righe da ...'
              onClick={togglePopup}
              disabled={!isRowSelected} />
          </Item>
          <Item location="before">
            <ToolbarButton className="offer-toolbar"
              icon='print'
              hint='Stampa'
              onClick={print}
              disabled={!isRowSelected} />
          </Item>
          <Item location="before">
            <ToolbarButton className="offer-toolbar"
              icon='newfolder'
              hint='Crea Commessa'
              onClick={createProject}
              disabled={!isGoToProject} 
              visible={true}/>
          </Item>
          <Item location="before">
            <ToolbarButton className="offer-toolbar"
              icon='columnchooser'
              hint='Aggiungi a Commessa'
              onClick={togglePopup2}
              disabled={!isGoToProject} 
              visible={true}/>
          </Item>

          <Item location="after">
            <CheckBox  
              value={isStorico} onValueChanged={onCheckValueChanged}
              defaultValue={isStorico}
              text="  Storico   "
            >
            </CheckBox>
          </Item>    
          <Item location="after"
            locateInMenu="auto"
            widget="dxSelectBox"
            options={selectBoxOptions} >
          </Item>

          <Item location="after"
            locateInMenu="auto"
            widget="dxSelectBox"
            options={selectBoxOptions2} >
          </Item>
          <Item location="after"
            locateInMenu="auto"
            widget="dxSelectBox"
            options={selectBoxOptions3} >
          </Item>
          { !isStorico
            &&   
            <>
           
            <Item location="after"
              locateInMenu="always"
              widget="dxTextBox"
              options={textBoxOptions} >
            </Item>

             <Item location="after"
              locateInMenu="always"
              widget="dxSelectBox"
              options={selectBoxOptions4} >
            </Item>

            <Item location="after"
              locateInMenu="always"
              widget="dxTextBox"
              options={textBoxOptions2} >
            </Item>
            </>
          } 
          <Item name="searchPanel" className="offer-toolbar"/>
        
        </Toolbar>
        
      }

      <HeaderFilter visible={true} />
      <Summary>
        <TotalItem
            column="numero"
            summaryType="count"
            customizeText={customizeText}
        />
      </Summary>
      <Selection mode="single" />

      <Editing
        mode="popup"
        allowUpdating={true}
        allowAdding={!isInProject}
        allowDeleting={true}
        useIcons={true}
      >
            
        <Popup title="Offerta" showTitle={true} width={1200} height={780} />
          <Form>
          
            <Item itemType="group" caption="Dati Offerta" colCount={4} colSpan={2}>
              <Item dataField="numero" colSpan={2} disabled={true}/>
              <Item dataField="dataDoc"colSpan={2} isRequired= "true"/>
              <Item dataField="dataScadenza"colSpan={2}/>
              <Item dataField="statoId"colSpan={2} />
              <Item dataField="tipoId"colSpan={2} isRequired= "true"/>
              <Item dataField="categoriaId"colSpan={2} isRequired= "true"/>
              <Item dataField="prioritaId" colSpan={2} isRequired= "true"/>
              <Item dataField="approvazioneTecnica" colSpan={2}/>
            </Item> 
            <Item itemType="group" caption="Progetto" colCount={4} colSpan={2}>
             <Item dataField="oggetto"colSpan={2}
                editorOptions={notesEditorOptions} isRequired= "true" >
                <Label text={`Nome`}/>
              </Item>
              <Item dataField="destinazione" colSpan={2} isRequired= "true"/>
              <Item dataField="localita" colSpan={2} isRequired= "true"/>
              <Item dataField="intermediarioId" colSpan={2} isRequired= "true"/>
              <Item dataField="riferimentoInternoId" colSpan={2} isRequired= "true"/>
              <Item dataField="riferimentoInterno2Id" colSpan={2} isRequired= "true"/>
           
            </Item>
            <Item itemType="group" caption="Cliente" colCount={4} colSpan={2}>
              <Item dataField="clienteId" colSpan={2} isRequired= "true">
                <Label text={`Denominazione`}/>
              </Item>
              <Item dataField="riferimentoCliente"colSpan={2}/>
              <Item dataField="emailRiferimento"colSpan={2} />
              <Item dataField="telefonoRiferimento"colSpan={2} />
              <Item dataField="dataScadenzaPresentazione"colSpan={2} isRequired= "true"/>
              <Item dataField="dataInvio"colSpan={2}/>
   
            
            </Item>  

            <Item itemType="group" caption="Altri Dati" colCount={4} colSpan={2}>
              <Item dataField="numeroOffertaRif"colSpan={2}/>
              <Item dataField="dataOffertaRif"colSpan={2} />
              <Item dataField="linkDocumenti"colSpan={2} />
              <Item dataField="rifOffertaFornitore"colSpan={2} />
              <Item dataField="statoCausaleId"colSpan={2} />
              <Item
                dataField="fornitoriIds" colSpan={2} editorType="dxTagBox"
                editorOptions={{
                  dataSource: fornitoriArray,
                  valueExpr: "id",
                  displayExpr: "alias",
                  searchEnabled: true,
                  placeholder:"",
                  multiline: true
                }}
                validationRules={[
                  {
                    type: "required",
                    message: "Seleziona almeno un fornitore"
                  }
                ]}
              />
              <Item dataField="master" colSpan={1}/>
              <Item dataField="raggruppaInStampa" colSpan={1}/>
              <Item dataField="percAcquisizione"colSpan={2} />
    
            </Item> 

            <GroupItem caption="Riepilogo" colCount={4} colSpan={2} >
              <TabbedItem colSpan={4}>
                <TabPanelOptions deferRendering={false} />
                <Tab title="Acquisto" colCount={4}>
                  <SimpleItem dataField="paTotale" editorOptions={editorOptions} disabled={true}/>
                  <SimpleItem dataField="pvTotale" editorOptions={editorOptions} disabled={true}/>
                  <SimpleItem dataField="delta" editorOptions={editorOptions} disabled={true}/>
                  <SimpleItem dataField="margine" editorOptions={editorOptionsPerc} disabled={true}/>
                </Tab>               
                <Tab title="Vendita" colCount={3}>
                  <SimpleItem dataField="importoLordo" editorOptions={editorOptions} disabled={true}/>
                  <SimpleItem dataField="percSconto" />
                  <SimpleItem dataField="importoSconto" editorOptions={editorOptions}/>
              
                  <SimpleItem dataField="imponibile" editorOptions={editorOptions} disabled={true}/>
                  <SimpleItem dataField="imposte" editorOptions={editorOptions} disabled={true}/>
                  <SimpleItem dataField="importoTotale" editorOptions={editorOptions} disabled={true}/>
                  <SimpleItem dataField="percCommissione" editorOptions={editorOptionsPerc} disabled={true}/>
                  <SimpleItem dataField="importoCommissione" editorOptions={editorOptions} disabled={true}/>
                </Tab>
                <Tab title="Imposte" colCount={3}>
                  <DataGrid id="grid-subcontainer"
                  dataSource={remoteDataSource2}
                  >
                    <Column dataField="id" visible={false}/>
                    <Column dataField="codiceIva"width={80}/>
                    <Column dataField="aliquotaIva"  visible={true}>
                      <Format type="fixedPoint" precision={2} />
                    </Column>
                    <Column dataField="imponibile"  visible={true}>
                      <Format type="fixedPoint" precision={2} />
                    </Column>
                    <Column dataField="imposta"  visible={true}>
                      <Format type="fixedPoint" precision={2} />
                    </Column>
                  </DataGrid>
                </Tab> 
                <Tab title="Soggetti" colCount={3}>
                  <DataGrid id="grid-subcontainer2"
                    dataSource={remoteDataSource4}>
                    <Editing
                      mode="form"
                      allowUpdating={isEditable}
                      useIcons={true}
                    >
                      <Form>
                        <Item dataField="nome"/>
                        <Item dataField="indirizzo"/>
                        <Item dataField="città"/>
                        <Item dataField="provincia"/>
                        <Item dataField="cap"/>
                        <Item dataField="nazione"/>
                        <Item dataField="piva"/>
                        <Item dataField="cf"/>
                        <Item dataField="codiceDestinatario"/>
                        <Item dataField="pec"/>
                      </Form>
                    </Editing>
                    <Column dataField="id" visible={false}/>
                    <Column dataField="tipoSoggettoId" caption="Tipo" width={120} >
                      <Lookup dataSource={tipiSoggetto} valueExpr="id" displayExpr="nome" />
                    </Column>
                    
                    <Column dataField="nome" width={200}/>
                    <Column dataField="indirizzo" width={200}/>
                    <Column dataField="città"/>
                    <Column dataField="provincia" width={80} visible={false}/>
                    <Column dataField="cap" width={80} visible={false} />
                    <Column dataField="nazione" visible={false}/>
                    <Column dataField="piva" width={120}/>
                    <Column dataField="cf" width={150}/>
                    <Column dataField="codiceDestinatario" width={120} caption="Cod. Dest." visible={false} />
                    <Column dataField="pec" width={120} visible={false}/>
                    
                  </DataGrid>
                </Tab> 
                </TabbedItem>
              </GroupItem>
              
              <Item itemType="group" caption="Dati Pagamento" colCount={4} colSpan={2}>
                <Item dataField="valutaId" colSpan={2}/>
                <Item dataField="modalitaPagamentoId" colSpan={2}/>
                <Item dataField="condizioniPagamentoId" colSpan={2}/>
                <Item dataField="condizioniPagamento2Id" colSpan={2}/>
              </Item>

              <Item itemType="group" caption="Note" colCount={4} colSpan={2}>
              <Item 
                  dataField="noteStampa"
                  editorType="dxTextArea"
                  colSpan={4}
                  editorOptions={notesEditorOptionsLarge} />
              <Item
                  dataField="descrizione"
                  editorType="dxTextArea"
                  colSpan={4}
                  editorOptions={notesEditorOptionsLarge} />
              </Item>

            </Form>
          </Editing>
          <Column dataField="id" visible={false}/>
          <Column dataField="numero" caption="Num." width={80}/>
          <Column dataField="dataDoc" dataType="date" format= {'dd/MM/yyyy'} caption="Data doc." width={130}/>
          <Column dataField="dataScadenza" dataType="date" format= {'dd/MM/yyyy'} caption="Data Scadenza" width={130} visible={false} />
          <Column dataField="noteStampa" caption="In stampa" visible={false}/>
          <Column dataField="descrizione" caption="Interne" visible={false}/>
          <Column dataField="oggetto" caption="Progetto"  visible={true} width={400}/>
          <Column dataField="clienteId" caption="Cliente" >
            <Lookup dataSource={clienti} valueExpr="id" displayExpr="ragioneSociale" />
          </Column>
       
          <Column dataField="destinazioneId" caption="Destinatario"  visible={false}>
            <Lookup dataSource={clienti} valueExpr="id" displayExpr="ragioneSociale" />
          </Column>
          <Column dataField="intermediarioId" caption="Azienda" visible={false} >
            <Lookup dataSource={intermediari} valueExpr="id" displayExpr="ragioneSociale" />
          </Column>
          <Column dataField="concorrenteId" caption="Concorrente"  visible={false} showClearButton={true}>
            <Lookup dataSource={concorrenti} valueExpr="id" displayExpr="ragioneSociale" />
          </Column>
          <Column dataField="fornitoriIds" caption="Fornitori" 
          // ✨ AGGIUNGI QUI LA LOGICA DI CALCOLO DEL VALORE
              calculateCellValue={(rowData) => {
                const value = rowData.fornitoriIds;
                // Se è già un array (e.g. durante l'editing), lascialo così
                if (Array.isArray(value)) {
                  return value;
                }
                // Se è una stringa CSV dal DB, convertila in Array di numeri
                if (typeof value === "string" && value.length > 0) {
                  try {
                    return value.split(",").map(n => Number(n)).filter(x => !isNaN(x));
                  } catch {
                    return [];
                  }
                }
                return [];
              }}

          visible={false}/>

          <Column dataField="numeroOffertaRif" caption="Numero Offerta Rif." visible={false}/>
          <Column dataField="dataOffertaRif" caption="Data Offerta Rif." dataType="date" format= {'dd/MM/yyyy'} visible={false}/>
    
          <Column dataField="statoCausaleId" caption="Motivazione Persa" visible={false} showClearButton={true}>
            <Lookup dataSource={statoCausali} valueExpr="id" displayExpr="descrizione" />
          </Column>
          <Column dataField="riferimentoInternoId" caption="Manager" >
            <Lookup dataSource={collaboratori} valueExpr="id" displayExpr="cognome" />
          </Column>
          <Column dataField="riferimentoInterno2Id" caption="Deputy" width={125} visible={false}>
            <Lookup dataSource={collaboratori} valueExpr="id" displayExpr="cognome" />
          </Column>
          <Column dataField="master"  visible={false}></Column>
          <Column dataField="raggruppaInStampa"  visible={false}></Column>
          <Column dataField="paTotale" caption="Prezzo Acquisto" visible={false}></Column>
          <Column dataField="pvTotale" caption="Prezzo Vendita" visible={false}></Column>
          <Column dataField="delta" caption="Delta" visible={false}></Column>
          <Column dataField="margine" caption="Margine" visible={false}></Column>

          <Column dataField="percCommissione" caption="% Commissione" visible={false} ></Column>
         

          <Column dataField="importoLordo"  visible={false}></Column>
          <Column dataField="percSconto"  visible={false}></Column>
          <Column dataField="importoSconto" visible={false}></Column>
          <Column dataField="importoScontato"  visible={false}></Column>
          <Column dataField="valutaId" caption="Valuta" width={80} visible={false}>
            <Lookup dataSource={valute} valueExpr="id" displayExpr="codice" />
          </Column>
          <Column dataField="imponibile"  visible={true} width={100}>
            <Format type="fixedPoint" precision={2} /> 
          </Column>
          <Column dataField="imposte"  visible={true} width={100}>
            <Format type="fixedPoint" precision={2} />
          </Column>
          <Column dataField="importoTotale"  width={100} caption="Totale">
            <Format type="fixedPoint" precision={2} />
          </Column>
           <Column dataField="importoCommissione" caption="Commissione" visible={true} disabled={true} width={100}>
            <Format type="fixedPoint" precision={2} /> 
          </Column>
          <Column dataField="statoId" caption="Stato" width={110}>
            <Lookup dataSource={stati} valueExpr="id" displayExpr="nome" />
          </Column>

          <Column
            caption=""
            width={40}
            cellRender={({ data }) => {
              if (!data.parentId) return null;
              if (data.parentId && data.versione) return null;
              return (
                <i
                  className="dx-icon-link"
                  style={{ color: "#1222d9ff", fontSize: 18 }}
                  title={`Collegata all'offerta ${data.numeroOffertaRif}`}
                />
              );
            }}
          />

          <Column dataField="modalitaPagamentoId"  caption="Modalità Pagamento" visible={false}>
            <Lookup dataSource={modalitaPagam} valueExpr="id" displayExpr="descrizione" />
          </Column>
          <Column dataField="condizioniPagamentoId" caption="Condiz. Pagamento Materiali" visible={false}>
            <Lookup dataSource={condizioniPagam} valueExpr="id" displayExpr="descrizione" />
          </Column>
          <Column dataField="condizioniPagamento2Id" caption="Condiz. Pagamento Prestazioni" visible={false}>
            <Lookup dataSource={condizioniPagam} valueExpr="id" displayExpr="descrizione" />
          </Column>
          <Column dataField="tipoId" caption="Tipo" width={80} visible={false}>
            <Lookup dataSource={tipiOfferta} valueExpr="id" displayExpr="nome" />
          </Column>
          <Column dataField="categoriaId" caption="Categoria" width={80} visible={false}>
            <Lookup dataSource={categorieOfferta} valueExpr="id" displayExpr="nome" />
          </Column>
          <Column dataField="prioritaId"  width={110} caption="Priorità" visible={false}>
            <Lookup dataSource={prioritaOptions} displayExpr="desc" valueExpr="id" />
          </Column>
          <Column dataField="percAcquisizione" caption="Probabilità di acquisizione" visible={false}>
            <Lookup dataSource={acquisizioneOptions} displayExpr="desc" valueExpr="id" />
          </Column>
          <Column dataField="dataScadenzaPresentazione" dataType="date" format= {'dd/MM/yyyy'} caption="Scadenza Presentazione" visible={false} />
          <Column dataField="dataInvio" dataType="date" format= {'dd/MM/yyyy'} caption="Data Invio" visible={false} />
          <Column dataField="riferimentoCliente" caption="Riferimento Cliente"  visible={false}/>
          <Column dataField="rifOffertaFornitore" caption="Rif. Offerta Fornitore"  visible={false}/>
          <Column dataField="linkDocumenti" visible={false}/>
          <Column dataField="updateBy" visible={false}/>
          <Column dataField="createBy" visible={false}/>
        
          <Column dataField="destinazione" visible={false}/>
          <Column dataField="localita" visible={false}/>
          <Column dataField="emailRiferimento" visible={false}/>
          <Column dataField="telefonoRiferimento" visible={false}/>

          <Column dataField="deputyUserId" visible={false}/>

          <Column dataField="approvazioneTecnica"  visible={false}></Column>

          <Column type="buttons">
            <Button name="edit"  />
            <Button name="delete" visible={hideEditButton}/>
          </Column>
        

        <MasterDetail
          enabled={true}
          component={offerDetail}
        />
      </DataGrid>

      <div>
        <Popup
          width={1000}
          height={640} 
          showTitle={true}
          title="Copia Righe"
          visible={isPopupVisible}
          hideOnOutsideClick={true}
          onHiding={togglePopup}
          contentRender={renderContent}
        > 
        </Popup> 
      </div>

      <div>
        <Popup
          width={800}
          height={640} 
          showTitle={true}
          title="Seleziona Commessa"
          visible={isPopupVisible2}
          hideOnOutsideClick={true}
          onHiding={togglePopup2}
          contentRender={renderContent2}
        > 
        </Popup> 
      </div>

      <div>
        <Popup
          width={600}
          height={400} 
          showTitle={true}
          title="Importa modello"
          visible={isPopupVisible3}
          hideOnOutsideClick={true}
          onHiding={togglePopup3}
          contentRender={renderContent3}
        > 
        </Popup> 
      </div>

       <div>
        <Popup
          width={480}
          height={260} 
          showTitle={true}
          title="Duplica Offerta"
          visible={isPopupVisible4}
          hideOnOutsideClick={true}
          onHiding={togglePopup4}
          contentRender={renderContent4}
        > 
        </Popup> 
      </div>

      <div>
        <Popup
            width={800}
            height={420} 
            showTitle={true}
            title="Crea Commessa"
            visible={isPopupVisible5}
            hideOnOutsideClick={true}
            onHiding={togglePopup5}
            contentRender={renderContent5}
          > 
          </Popup> 
        </div>


      </div>
    </div>
  </React.Fragment>
)};
